//Knocking Object for globals

console.log("Knocking-Globals init");

var Knocking = {
  JSCart: [],
  total_price: 0,

  //Fetching cart from Shopify Ajax-API - Use Callback to filter output - Also updates total_price
  loadCart: function (callback) {
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        callback(JSON.parse(this.responseText));
        //console.log(JSON.parse(this.responseText));
      }
    };

    let root_url = Shopify.locale != "en" ? "/" + Shopify.locale : "";
    xhr.open("GET", root_url + "/cart.js", true);
    xhr.send();
  },
};
